import { render, staticRenderFns } from "./TrunksDetail.vue?vue&type=template&id=79957ec0"
import script from "./TrunksDetail.vue?vue&type=script&lang=ts"
export * from "./TrunksDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports